import React, {PureComponent} from "react"

import Flex from "@irati/ui/src/Flex"
import {TenantOnboardingStep} from "@irati/types"
import history from "@irati/utils/history"
import Routes, {SETUP_TENANT} from "@irati-web/app/src/routeConfig"
import {FormattedMessage} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import {H3} from "@irati/ui/src//Typography/Heading"
import {Para} from "@irati/ui/src/Labels"
import {WaitImage} from "../../styled"
import {getFirstIncompleteStep, getStepDetails} from "../../../helpers"

interface Props {
  tenantOnboardingSteps: TenantOnboardingStep[]
}

class NotReady extends PureComponent<Props> {
  handleClick = () => {
    const {nestedPath} = getStepDetails(getFirstIncompleteStep(this.props.tenantOnboardingSteps))
    history.push(`${Routes[SETUP_TENANT]}${nestedPath}`)
  }

  render() {
    return (
      <Flex direction="column" alignItems="flex-start">
        <WaitImage />
        <H3 base>
          <FormattedMessage id="setup_tenant.steps.invite.notready.title" />
        </H3>
        <Para margin="0 0 30px 0">
          <FormattedMessage id="setup_tenant.steps.invite.notready.text" />
        </Para>
        <Button onClick={this.handleClick} primary>
          <FormattedMessage id="setup_tenant.steps.invite.notready.button" />
        </Button>
      </Flex>
    )
  }
}

export default NotReady
